export const portfolioUploadSteps = {
  SELECT_TYPE: 0,
  UPLOAD: 1,
  CREATE_DOSSIER: 2,
  SUMMARY: 3,
  FINISH: 4,
};
